module.exports = __webpack_public_path__ + "img/exporo-logo-light.c4ee25ee.svg";